import { createSlice } from "@reduxjs/toolkit";
// import { signInUser } from "../Components/Utility/Auth";

// const user = signInUser();

const initialState = {
  article_code: "",
  supplier: "",
  inventoryId: "",
  tp: "",
  mrp: "",
  order: "",
  warehouse: "",
  status: "inactive",
};
export const productPriceSlice = createSlice({
  name: "productPrice",
  initialState: initialState,
  reducers: {
    selectWareHouse: (state, action) => {
      return { ...state, warehouse: action.payload };
    },
    selectStatus: (state, action) => {
      return { ...state, status: action.payload };
    },
    selectUpdateProduct: (state, action) => {
      return { ...state, photo: action.payload };
    },
    resetProductPrice: () => initialState,
  },
});
export const {
  selectWareHouse,
  selectStatus,
  resetProductPrice,
  selectUpdateProduct,
} = productPriceSlice.actions;
export const productPriceReducer = productPriceSlice.reducer;
